import * as Immutable from "immutable";

export default class UserModel extends Immutable.Record({
    id: 0,
    nick: "",
    name: "",
    avatar: "",
    editor: false,
    premium: false,
    badge: "",
    verified: false,
}) {

    public getId(): number {
        return this.get("id");
    }

    public getAvatar(): string {
        return this.get("avatar");
    }

    public getNick(): string {
        return this.get("nick");
    }

    public getName(): string {
        return this.get("name");
    }

    public isEditor(): boolean {
        return this.get("editor");
    }

    public hasPremium(): boolean {
        return this.get("premium");
    }

    public getBadge(): string {
        return this.get("badge");
    }

    public isVerified(): boolean {
        return this.get("verified");
    }
}